// extracted by mini-css-extract-plugin
export var infoRow = "_rz-2";
export var labelContainer = "_rz-0";
export var rightInfo = "_rz-1";